exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{padding-bottom:275px}@media (max-width:992px){#app{padding-bottom:350px}}@media (max-width:767px){#app{padding-bottom:400px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a9de4882","scoped":false,"hasInlineConfig":true}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/dashboard/Dashboard.vue
// module id = NPAF
// module chunks = 1